<template>
	<div class="page">
		<div class="logo">
			<img src="../assets/images/logo/logo2.png" alt="" />
		</div>
		<div class="theme-logo"></div>
		<div class="sub-logo"></div>
		<!-- 按钮组 -->
		<div class="menu" v-for="item in menuList" :key="item.url" @click="toDetail(item.link)">
			<img :src="item.url" alt="">
		</div>
	</div>
	<BottomNav />
</template>

<script setup>
import { ref } from "vue";
import BottomNav from "../components/BottomNav.vue";
import { useRouter } from 'vue-router';

const router = useRouter();

const menuList = ref([
	{
		url: require("../assets/images/service/sign.png"),
		link: "/signin",
	},
	{
		url: require("../assets/images/service/hotel.png"),
		link: "/hotel",
	},
	{
		url: require("../assets/images/service/dining.png"),
		link: "/dining",
	},
	{
		url: require("../assets/images/service/tips.png"),
		link: "/tip",
	},
	{
		url: require("../assets/images/service/live.png"),
		link: "https",
	},
	//   {
	//     url: require("../assets/images/scene.png"),
	// 	link: "/sceneUp",
	//   },
]);

const toDetail = (url) => {
	if (url === "https") {
		window.location.href = "https://live.pailixiang.com/album/a13173361627";
		return;
	}
	router.push({
		path: url,
		query: {

		},
	});
};
</script>

<style scoped>
.page {
	width: 100vw;
	height: calc(100vh - 50px);
	background: url("../assets/bg/718.jpg") 100% 100% no-repeat;
	background-size: cover;
    padding-top: 24px;
    box-sizing: border-box;
}

.logo img {
	width: 40%;
	height: auto;
	display: block;
	padding: 20px 0;
	/* margin-left: 10%; */
	/* padding-top: 10%; */
    margin: auto;
}

.sub-logo {
	width: 90%;
	height: 30px;
	background: url("../assets/images/logo/text.png") no-repeat center center;
	background-size: contain;
	margin: auto;
}

.theme-logo {
	width: 80%;
	height: 60px;
		background: url("../assets/images/logo/aiTitle.png") no-repeat center center;
	background-size: contain;
	margin: auto;
}

.menu img {
	width: 80%;
    max-height: 68px;
	display: block;
	margin: 20px auto;
}
</style>
